import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {EmbeddedImageFieldInputTypeHandlerComponent} from './embedded-image-field-input-type-handler.component';
import {FileUploadModule} from '../../../../file-upload/file-upload.module';
import {ButtonModule} from '../../../../../../modules/core/component/button/button.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        FileUploadModule,
        ButtonModule,
    ],
    declarations: [
        EmbeddedImageFieldInputTypeHandlerComponent,
    ],
    exports: [
        EmbeddedImageFieldInputTypeHandlerComponent,
    ],
})
export class EmbeddedImageFieldInputTypeHandlerModule {}
